<div class="d-flex flex-column justify-content-center wrapper" *ngIf="bigBangSideBarData">
  <div class="offcanvas-body d-flex align-items-center title">
    <h1>FY{{ prizeDrawQuarter }} <br class="d-none d-lg-block" />{{ 'Prize draw' | translate }}</h1>
  </div>
  <div class="offcanvas-body d-flex flex-column main-body">
    <div *ngIf="endDate">
      <div class="my-3">{{ 'Next prize draw:' | translate }}</div>
      <div class="d-flex align-items-center countdown">
        <app-countdown [endDate]="endDate" class="w-100"></app-countdown>
      </div>
    </div>
    <div class="my-5 d-flex justify-content-between">
      {{ (user$ | async)?.firstName }} {{ (user$ | async)?.lastName }} <strong>{{ numberOfCompletedTickets }}/3</strong>
    </div>
    <div class="d-flex flex-column gap-3">
      <app-big-bang-progress-ticket
        [ticketNumber]="1"
        [percentageCompleted]="firstTicketCompletedPercentage"
      ></app-big-bang-progress-ticket>
      <app-big-bang-progress-ticket
        [ticketNumber]="2"
        [percentageCompleted]="secondTicketCompletedPercentage"
      ></app-big-bang-progress-ticket>
      <app-big-bang-progress-ticket
        [ticketNumber]="3"
        [percentageCompleted]="thirdTicketCompletedPercentage"
      ></app-big-bang-progress-ticket>
    </div>
    <div class="mt-4 d-flex justify-content-center align-items-center points-left-container">
      {{ 'Pts until next ticket:' | translate }}
      <div class="ms-1 points-left">{{ pointsTillNextTicket | number }}</div>
    </div>
    <div class="my-5 d-flex justify-content-between">
      <div>
        {{ 'Total Q4 grand prize tickets' | translate }}
      </div>
      <strong>{{ bigBangSideBarData.totalTickets }}/9</strong>
    </div>
  </div>
</div>
